import React from 'react';

import SVGIcon, { GENERAL_ICONS } from 'src/components/svg';
import BaseAnalyseItem from 'src/components/analyse/item';
import { lang, userFullName } from 'src/helpers';

export default class ReplyItem extends BaseAnalyseItem {
  render() {
    const { item, auth, partnerName } = this.props;
    let mediaType = item.media && item.media.length == 1 && item.media[0].fileType;
    let type = item.msgType || mediaType || 'text';
    return (
      <div className={'mc-flex-10-col'}>
        <div className={'mc-b2b mc-pb5'}>
          <div className={'mc-forward'}>
            <SVGIcon iconname={GENERAL_ICONS.REPLY} />
            <span>{lang.t('Reply ')}</span>
            <span className={'mc-value-516'}>
              {lang.t('by ') +
                (item.from === auth?.id ? userFullName(auth, auth?.isDoctor) : partnerName)}
            </span>
          </div>
          <div className={'mc-value-516'}>{item.data?.title || item.data?.diagnosis}</div>
        </div>
        <pre className={type === 'timeline' ? 'mc-label-418' : 'mc-value-418'}>{item.text}</pre>
      </div>
    );
  }
}
